const MAP: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function esc(v: unknown): string {
  return String(v ?? '').replace(/[&<>"']/g, (c) => MAP[c]);
}

/** Текст с сохранением абзацев: экранирование + <p>/<br>. Никогда не выводит HTML пользователя. */
export function paragraphs(text: string): string {
  return String(text ?? '')
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => `<p>${esc(p).replace(/\n/g, '<br>')}</p>`)
    .join('');
}

export function pct(share: number | null): string {
  return share === null ? '—' : `${Math.round(share * 100)}%`;
}

export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10, m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}
export const votesWord = (n: number) => `${n} ${plural(n, 'голос', 'голоса', 'голосов')}`;
export const participantsWord = (n: number) => `${n} ${plural(n, 'участник', 'участника', 'участников')}`;
export const answersWord = (n: number) => `${n} ${plural(n, 'ответ', 'ответа', 'ответов')}`;
